import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { cn } from "@/lib/utils";

const cache = new Map();

export function fetchFileBlobUrl(id) {
  if (cache.has(id)) return cache.get(id);
  const promise = api.get(`/files/${id}`, { responseType: "blob" }).then((r) => URL.createObjectURL(r.data));
  cache.set(id, promise);
  promise.catch(() => cache.delete(id));
  return promise;
}

export async function openFile(id) {
  const url = await fetchFileBlobUrl(id);
  window.open(url, "_blank", "noopener");
}

export function SecureImage({ fileId, alt = "", className, ...props }) {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let alive = true;
    setSrc(null);
    setFailed(false);
    fetchFileBlobUrl(fileId).then((u) => alive && setSrc(u)).catch(() => alive && setFailed(true));
    return () => {
      alive = false;
    };
  }, [fileId]);
  if (failed) return <div className={cn("grid place-items-center bg-muted text-[10px] text-muted-foreground", className)}>Indisponible</div>;
  if (!src) return <div className={cn("animate-pulse bg-muted", className)} data-testid="secure-image-loading" />;
  return <img src={src} alt={alt} className={className} {...props} />;
}
